import { Icon } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PdfChip = ({ record }) => {
  const { t } = useTranslation();

  return (
    <div style={{ cursor: 'pointer' }} onClick={() => {
      console.log('record', record);
      window.open(record.eInvoicePdf, '_blank');
    }} className="pdf-chip">
      <div className="icon">
        <Icon className="icon-blue icon-small">picture_as_pdf</Icon>
      </div>
      <div className="pdf-chip-text">{t('invoice.Pdf')}</div>
    </div>
  );
};

export default PdfChip; 